import { mounterFor } from './util';
import Type from 'union-type';
import * as R from 'ramda';
import {
  h,
} from "snabbdom";


// STATE
// {
//   question: string
//   type: text | radio | checkbox
//   options: []{text: string, details: string, selected: bool, image: string}
//   response: string
//   autocomplete: bool
// }
 
const baseOptionView = (action$, state, actionConstructor) => {
  const columns = state.isMobile ? 1 : state.columns || 1;
  const nextButton = document.querySelector('.Survey-right');
  let isSelected = false;

  const optionsDiv = h('div.Question-options', {
    style: {gridTemplateColumns: `repeat(${columns}, 1fr)`},
  }, 
    state.options.map((opt, i) => {
    if (opt.selected) {
      isSelected = true
    }
    const optText = h('div.Question-optionLabel', {}, opt.text)
      const optChildren = [h('span.Question-selectedCircle', {
        class: {'is-selected': opt.selected},
      }, []), optText];
 
      return h('button.Question-option', {
        props: {type: 'button'},
        class: {'is-selected': opt.selected},
        on: {click: () => action$(actionConstructor(i))}
      }, optChildren)
    }),
  );
  if (nextButton) {
    nextButton.style.borderColor = isSelected ? "#008555" : "";
    nextButton.style.color = isSelected ? "#008555" : "";
  }
  return optionsDiv;
}

const checkBoxOptionView = (action$, state, actionConstructor) => {
  const columns = state.isMobile ? 1 : state.columns || 1;
  return h('div.Question-options', {
    style: {gridTemplateColumns: `repeat(${columns}, 1fr)`},
  }, 
    state.options.map((opt, i) => {

        const optChildren = 
          [h('input.Question-checkBoxInput.js-survey-checkbox', {
              on: {input: e  => {
                action$(Action.SetResponse(e.target.value))
              }}, 
              props: {value: 'consent', type: "checkbox"}}, 
              []),
              h('label.Question-checkBoxLabel', {}, opt.text)
          ] ;
 
          return h('div.Question-checkboxInputWrapper', {}, optChildren)
    }),
  );
}
 
const radioDetailsView = (action$, state) => {
  const columns = state.isMobile ? 1 : state.columns || 1;
  const submitButton = document.querySelector('.Survey-submit');
  let isSelected = false;
  const radioDetail = h('div.Question-options--radioDetail', {
    style: {gridTemplateColumns: `repeat(${columns}, 1fr)`},
  }, 
    state.options.map((opt, i) => {
      if (opt.selected) {
        isSelected = true
      }

      return h('button.Question-option.Question-option--detailed', {
      props: {type: 'button'},
      on: {click: () => action$(Action.SetExclusiveOption(i))}
    }, [
      h('div.Question-optionHeading', {}, [
        h('span.Question-selectedCircle', {
          class: {'is-selected': opt.selected},
        }, []),
        h('span.Question-optionTitle', {}, [opt.text]),
      ]),
    ])}),
  );
  if (submitButton) {
    submitButton.style.borderColor = isSelected ? "#008555" : "";
    submitButton.style.color = isSelected ? "#008555" : "";
  }
  return radioDetail
}
 
const radioView = (action$, state) => {
  return baseOptionView(action$, state, Action.SetExclusiveOption)
}
 
const checkboxView = (action$, state) => {
  return (state.specifier === 'consent') ? checkBoxOptionView(action$, state, Action.ToggleOption) : baseOptionView(action$, state, Action.ToggleOption);
}
 
const correctQuestionView = (action$, state) => {
  return state.type === 'radio' ? radioView(action$, state)
       : state.type === 'checkbox' ? checkboxView(action$, state)
       : state.type === 'radiodetails' ? radioDetailsView(action$, state)
       : h('div', {}, ['Unknown Question Type'])
}
 
const view = R.curry((action$, state) => {
  const hasSubtitle = state.subtitle;

  return h('div.Question', {}, [
    h('div.Question-prompt', {}, [
      h('div.Question-title', {}, state.question),
      hasSubtitle ? h('div.Question-subtitle', {}, state.subtitle) : h('span')
    ]),
    correctQuestionView(action$, state),
  ])
})
 
const Action = Type({
  Clear: [],
  SetResponse: [() => true],
  ToggleOption: [Number],
  SetExclusiveOption: [Number],
})
 
const update = (state, action) => {

  // Adding analytics for each card option click
  const event = new ANSWERS.AnalyticsEvent('CTA_CLICK')
  .addOptions({
    directAnswer: false,
    searcher: 'UNIVERSAL',
    verticalKey: 'universal',
    ctaLabel: `card${state["number"]}_${state.options?.[action[0]]?.analyticsLabel ?? (action[0] + 1)}`,
    entityId: 'GuidedSearch' //hardcoded entity id
  });
  ANSWERS.core._analyticsReporter.report(event)

  return Action.case({
    Clear: (state) => ({...state, response: '', options: state.options.map(opt => ({...opt, selected: false}))}),
    SetResponse: (response, state) => ({...state, response: response}),
    ToggleOption: (i, state) => ({...state, options: state.options.map((opt, idx) => idx === i ? {...opt, selected: !opt.selected}: opt)}),
    SetExclusiveOption: (i, state) => {
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({
        "question_title": state.question,
        "item_selected": state.options[i],
        "template_name": "survey"
      });
      return ({...state, options: state.options.map((opt, idx) => idx === i ? {...opt, selected: true}: {...opt, selected: false})});
    },
  }, action, state)
}
 
const mount = mounterFor({
  view,
  update,
});
 
export default { view, update, mount, Action};